const collection = {
    slug: "orlando",
    metaTitle:
      "COMME des GARÇONS HOMME PLUS 2020SS Orlando｜Enclopedia Archive Study",
    metaDescription:
      "COMME des GARÇONS HOMME PLUS 2020SS『Orlando』を、文学・時間・ジェンダーの視点から読み解くEnclopediaのアーカイブ解説ページです。",
    metaKeywords:
      "COMME des GARCONS HOMME PLUS 2020SS,Orlando,オーランドー,コムデギャルソンオムプリュス,アーカイブファッション,コレクション解説,enclopedia,アンクロペディア",
    canonicalPath: "/archive_collection/comme_des_garcons_homme_plus_2020ss_orlando",
    heroImage: "media/collection/archive2.png",
    heroImageAlt:
      "COMME des GARÇONS HOMME PLUS 2020SS Orlandoのアーカイブコレクション画像",
    heroNumber: "02 / ORLANDO",
    label: "ARCHIVE COLLECTION STUDY",
    title: "COMME des GARÇONS HOMME PLUS 2020SS『Orlando』",
    lead:
      "ヴァージニア・ウルフ『オーランドー』を起点に、時代・性・衣服の境界を横断したコレクション。\n古典的な服の形式を借りながら、それを固定された記号ではなく、変化し続ける身体のための装置として読み替えます。",
    keywordLine: ["literature", "transformation", "gender", "time"],
    thesis:
      "『Orlando』の重要性は、過去の様式を引用しながら、“男性服”“女性服”という見え方そのものを流動化した点にあります。",
    whyTitle: "服は、誰のものか。『Orlando』はその問いを曖昧にする。",
    whyBody:
      "2020SSのHOMME PLUSは、文学作品の世界観を単に引用するのではなく、服の形そのものへ翻訳しました。\n時代を越える身体、性別を横断する存在、固定されない自己。その感覚が、テーラリング、装飾、レイヤーの中に現れます。",
    pillars: [
      {
        number: "01",
        title: "LITERATURE INTO CLOTHES",
        text:
          "『オーランドー』の持つ時間の長さと変身の物語を、服のシルエットと重なりによって可視化する。",
      },
      {
        number: "02",
        title: "HISTORY IN COLLISION",
        text:
          "フロックコート、ドレス的な量感、現代的な軽さを同居させ、歴史衣装の再現ではなく、時代の衝突を作る。",
      },
      {
        number: "03",
        title: "BEYOND FIXED GENDER",
        text:
          "男性服と女性服を分けるコードをあえて揺らし、着る人の身体が一つの答えへ固定されない余白を残します。",
      },
    ],
    readingTitle: "ルックとディテールから読む、変化する身体のための服。",
    readingIntro:
      "『Orlando』は、装飾が多いから面白いのではありません。どの装飾が、どの歴史や身体感覚を横断しているかを見ることで、深度が変わります。",
    observations: [
      {
        index: "01",
        title: "古典的なテーラリングに、ドレス的な量感を接続",
        text:
          "肩や上半身には構築性が残る一方で、裾やレイヤーは流動的に広がる。男性服の秩序を保ちながら、その輪郭を別の身体へ開いています。",
      },
      {
        index: "02",
        title: "フリルや装飾を“役割”から自由にする",
        text:
          "装飾は性別を示す記号ではなく、時間の混線や視線の移動を作る要素として働く。飾りが分類を越えるための手段になります。",
      },
      {
        index: "03",
        title: "過去の様式と現代性を同時に置く",
        text:
          "歴史的なフォルムに、現代的な軽さやスピード感を重ねることで、物語の中で時間を越える主人公の感覚が服の上に立ち上がります。",
      },
    ],
    quote:
      "『Orlando』は、服を“誰のものか”で分けるのではなく、“どう変化できるか”で読み直すための提案です。",
    perspectiveTitle: "Enclopediaは、文学と服の間にある距離を、実物体験で縮める。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "文学、ショー、ブランドの意図をつなぎ、なぜ『Orlando』がHOMME PLUSで扱われたのかを可視化します。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "着用すると、丈感、重心、レイヤーの揺れ方が、写真とは違う理解を生みます。服を考える体験へ変えます。",
      },
      {
        number: "03",
        title: "COMMUNITY",
        text:
          "ジェンダー、文学、歴史衣装、舞台芸術に関心のある人が自然に集まる文脈を作り、アーカイブへの入口を広げます。",
      },
    ],
    experienceTitle: "『Orlando』は、読むだけではなく、着ることで輪郭が変わる。",
    experienceBody:
      "画面上では装飾やシルエットとして見える差異が、実際に身体へ乗ると、丈感、重心、視線の集まり方として理解できます。\nEnclopediaでは、アーカイブを所有物ではなく、考え方を身体で辿るメディアとして扱います。",
    experienceItems: [
      "シルエットの重心を身体で知る",
      "装飾とテーラリングの共存を体感する",
      "背景を読んだ後にレンタルで確かめる",
    ],
    archiveItemsTitle: "このテーマを、実物で確かめる。",
    archiveItemsBody:
      "在庫導線には、Orlandoの世界観と接続できる視点を添え、単なる一覧ではなく、コレクション理解の続きを設計します。",
    archiveItems: [
      {
        label: "ARCHIVE FOCUS 01",
        title: "Tailoring Beyond Gender",
        productPath: "/product/8bf5cd8f-d952-4a04-b1c3-34fc46c6c2d5",
        productImage:
          "media/product/1727838682.84216768bf5cd8f-d952-4a04-b1c3-34fc46c6c2d5.png",
        text:
          "男性服の構築性を保ちながら、別の身体感覚へ開いていく一着を読む導線。",
      },
      {
        label: "ARCHIVE FOCUS 02",
        title: "Historical Form / Modern Energy",
        productPath: "/product/0f19e891-2910-4f0a-803d-a593a175ffbf",
        productImage:
          "media/product/1739200273.155390f19e891-2910-4f0a-803d-a593a175ffbf.jpg",
        text:
          "歴史的なフォルムと現在の軽さを同時に扱う、Orlandoらしい混線を示す導線。",
      },
      {
        label: "ARCHIVE FOCUS 03",
        title: "Dressing as Transformation",
        productPath: "/product/034d9b02-fe70-48fc-87af-808c691f88be",
        productImage:
          "media/product/1727830116.7223113034d9b02-fe70-48fc-87af-808c691f88be.png",
        text:
          "着ることで意味が変わる。体験の入口としてレンタルへつなぐ導線。",
      },
    ],
  };

export default collection;
